import { Module } from "vuex-module-decorators";
import FormModule from "@/core/base/FormModule";

@Module({ namespaced: true })
export default class EmailSetting extends FormModule {
  override endPoint = "emailSetting";
}
